import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Axios from "axios";

class Provincial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      products: [],
    };
  }

  componentDidMount() {
    document.title = "Karamale - Provincial ranking ";
    Axios.get("http://192.168.8.103:3002/api/select/ranking/provincial").then(
      (res) => {
        const products = res.data;
        this.setState({ products });
      }
    );
  }

  render() {
    const { error, products } = this.state;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else {
      return (
        <div className="row mt-4">
          {products.map((ranks) => (
            <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div
                className="nainer define-ranking-box"
                style={{
                  backgroundImage:
                    "url(http://192.168.8.103/karamalenew/public/saflag.jpg",
                }}
              >
                <div className="rank">{ranks.ranks}</div>
                <div className="row h-100">
                  <div className="col-12 align-self-end label-shadow-ranking">
                    <div className="row h-100">
                      <div className="col-12 pl-3 pr-3 align-self-center textLight case-sentence">
                        {ranks.province}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }
  }
}

export default Provincial;
